import { render } from "./StaffingRequirementView.vue?vue&type=template&id=2ea140b3&scoped=true"
import script from "./StaffingRequirementView.vue?vue&type=script&lang=js"
export * from "./StaffingRequirementView.vue?vue&type=script&lang=js"

import "./StaffingRequirementView.vue?vue&type=style&index=0&id=2ea140b3&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ea140b3"]])

export default __exports__